import React from 'react';

const CompliancePanel = () => {
  return (
    <section className="compliance-section">
      <div className="compliance-container">
        <h2 className="compliance-title">
          Built for Compliance
        </h2>
        
        <div className="compliance-panel">
          <ul className="compliance-list">
            <li className="compliance-item">
              <div className="compliance-bullet"></div>
              <p className="compliance-text">
                Identity verification (KYC/AML) and wallet whitelisting prior to allocation
              </p>
            </li>
            
            <li className="compliance-item">
              <div className="compliance-bullet"></div>
              <p className="compliance-text">
                Tokens record ownership and distributions on-chain; rights remain governed by offering documents
              </p>
            </li>
            
            <li className="compliance-item">
              <div className="compliance-bullet"></div>
              <p className="compliance-text">
                12-month transfer lockup, then participation in approved secondary markets where available. Liquidity not guaranteed
              </p>
            </li>
            
            <li className="compliance-item">
              <div className="compliance-bullet"></div>
              <p className="compliance-text">
                We monitor evolving guidance and align processes with applicable regulatory frameworks across jurisdictions
              </p>
            </li>
          </ul>
          
          <div className="compliance-note">
            <p className="compliance-note-text">
              Our first offering is international-first; references to regulators are jurisdiction-dependent. We prioritize compliant venues
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompliancePanel;


